// extracted by mini-css-extract-plugin
export default {"galleryContainer":"Gallery_galleryContainer__reD1m","imgBox":"Gallery_imgBox__2TddD","we":"Gallery_we__gzty3"};